function joinFileUrl(baseUrl, path) {
  if (!path) return "";

  return `${String(baseUrl || "").replace(/\/+$/, "")}/${String(path).replace(
    /^\/+/,
    ""
  )}`;
}

module.exports = {
  joinFileUrl,
};
